import PatientInfo from './components/patient-info';
import PatientList from './components/patient-list';
import { PhanHeBaoHiemYTeContextProvider } from './contexts';
import './style.scss';

const PhanHeBaoHiemYTe = () => {
	return (
		<PhanHeBaoHiemYTeContextProvider>
			<div className="bg-gray">
				<div className="d-flex">
					<div className="pe-0 spaces w-25 h-calc-vh-35 bg-white spaces pt-10">
						<div className="flex-1">
							<PatientList />
						</div>
					</div>

					<div className="pl-0 ml-pt-0_6 spaces border w-75">
						<PatientInfo />
					</div>
				</div>
			</div>
		</PhanHeBaoHiemYTeContextProvider>
	);
};

export default PhanHeBaoHiemYTe;
